/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import LoadPanel from "devextreme-react/load-panel";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import Form, { Label, Item, StringLengthRule } from "devextreme-react/form";
import { useSelector, useDispatch } from "react-redux";
import notify from "devextreme/ui/notify";
import { formatMessage } from "devextreme/localization";
import {
  responseMiddleware,
  responseTimekeeping,
} from "../../../redux/reducers";
import {
  IsPermisionPathRequired,
  showTimekeepingOnline,
} from "../../../redux/actions";
import "./style.scss";
import { useScreenSize } from "../../../utils/media-query";
import { useAuth } from "../../../contexts/auth";
import TimeKeepingOnlineTableList from "./TimekeepingOnlineTable";
import UsingIntl from "../../../services/using_intl";
import PopupConfig from "../../../common/popup";
import { convertDateToTime } from "../../../utils/date-time";
import { axios, SplitLink, getCurrentPath } from "../../../common";

const y = new Date().getFullYear(),
  m = new Date().getMonth();

export default function TimeKeepingOnlineList() {
  let dataGrid = useRef(null);
  const formData = useRef({});
  const { user } = useAuth();
  const dispatch = useDispatch();
  const history = useHistory();
  const { middlewarePath: middleware, loading } =
    useSelector(responseMiddleware);
  const currentPath = getCurrentPath();
  const { timekeepingOnline } = useSelector(responseTimekeeping);
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();
  const [timeString, setTimeString] = useState("");
  const { isSmall, isXSmall } = useScreenSize();
  const [filter, setFilter] = useState({
    Status: [0, 1, 2, 3, 4, 5],
    FromDate: new Date(y, m, 1).toLocaleDateString("en-CA"),
    ToDate: new Date(y, m + 1, 0).toLocaleDateString("en-CA"),
    EmployeeOid: user?.EmployeeOid,
  });

  useEffect(() => {
    UsingIntl("P0035");
    dispatch(IsPermisionPathRequired(currentPath));
  }, [dispatch]);

  React.useEffect(() => {
    const getData = async () => {
      switch (SplitLink(window.location.href)) {
        case "list?q=checkin":
          handleOpenPopup();
          break;
        default:
          break;
      }
    };
    getData();
  }, []);

  const handleChangeSelectBox = async () => {
    dispatch(showTimekeepingOnline(filter));
  };
  React.useEffect(() => {
    handleChangeSelectBox();
  }, [filter.Status]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  useEffect(() => {
    const clockInterval = setInterval(() => {
      const now = new Date();
      const newTimeString = convertDateToTime(now);
      setTimeString(newTimeString);
    }, 1000);
    return () => {
      clearInterval(clockInterval);
    };
  }, []);

  const handleCheckInProgress = async () => {
    const payload = {
      ...formData.current,
      Employee: { Oid: user.EmployeeOid },
      // LogTime: Date.now(),
    };
    try {
      const { data } = await axios.post("TimeKeepingOnline", payload);

      if (!data) {
        handleChangeSelectBox();
        notify("Check In/Out online has not been saved", "error", 3000);
        handleClosePopup();
        return;
      }
      handleChangeSelectBox();
      handleClosePopup();
      notify("Check In/Out online has been saved", "success", 3000);
    } catch (error) {
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };
  const renderViewPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={formatMessage("PopupTitle")}
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        borderRadius={10}
        closeOnOutsideClick={true}
      >
        <div className="long-title">
          <h3>{timeString}</h3>
        </div>
        <Form formData={formData.current}>
          <Item dataField="Remarks" editorType="dxTextArea" colSpan={2}>
            <StringLengthRule max="250" />
            <Label text={formatMessage("Remarks")} />
          </Item>
        </Form>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleCheckInProgress}
          options={{
            icon: "check",
            type: "default",
            text: formatMessage("Checkin"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };
  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("TimekeepingOnline")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/timekeeping-online/list" className={"breadcrumb-item"}>
            {formatMessage("Timekeeping")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("TimekeepingOnline")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderViewPopup()}

          <TimeKeepingOnlineTableList
            dataGrid={dataGrid}
            middleware={middleware}
            handleOpenPopup={handleOpenPopup}
            handleChangeSelectBox={handleChangeSelectBox}
            filter={filter}
            setFilter={setFilter}
            dataSource={timekeepingOnline}
          />
        </div>
      </div>
    </div>
  );
}
